// Complete list of Stripe Tax ID types as of API version 2025-10-29
// Source: https://docs.stripe.com/api/tax_ids/object excluding it_cf, it_vat, us_itin

export const TAX_ID_TYPES = [
  // A
  { value: 'ad_nrt', label: 'Andorra NRT', abbr: 'AD' },
  { value: 'ae_trn', label: 'United Arab Emirates TRN', abbr: 'AE' },
  { value: 'al_tin', label: 'Albania TIN', abbr: 'AL' },
  { value: 'am_tin', label: 'Armenia TIN', abbr: 'AM' },
  { value: 'ao_tin', label: 'Angola TIN', abbr: 'AO' },
  { value: 'ar_cuit', label: 'Argentina CUIT', abbr: 'AR' },
  { value: 'au_abn', label: 'Australia ABN', abbr: 'AU' },
  { value: 'au_arn', label: 'Australia ARN', abbr: 'AU' },
  { value: 'aw_tin', label: 'Aruba TIN', abbr: 'AW' },
  { value: 'az_tin', label: 'Azerbaijan TIN', abbr: 'AZ' },

  // B
  { value: 'ba_tin', label: 'Bosnia and Herzegovina TIN', abbr: 'BA' },
  { value: 'bb_tin', label: 'Barbados TIN', abbr: 'BB' },
  { value: 'bd_bin', label: 'Bangladesh BIN', abbr: 'BD' },
  { value: 'bf_ifu', label: 'Burkina Faso IFU', abbr: 'BF' },
  { value: 'bg_uic', label: 'Bulgaria UIC', abbr: 'BG' },
  { value: 'bh_vat', label: 'Bahrain VAT', abbr: 'BH' },
  { value: 'bj_ifu', label: 'Benin IFU', abbr: 'BJ' },
  { value: 'bo_tin', label: 'Bolivia TIN', abbr: 'BO' },
  { value: 'br_cnpj', label: 'Brazil CNPJ', abbr: 'BR' },
  { value: 'br_cpf', label: 'Brazil CPF', abbr: 'BR' },
  { value: 'bs_tin', label: 'Bahamas TIN', abbr: 'BS' },
  { value: 'by_tin', label: 'Belarus TIN', abbr: 'BY' },

  // C
  { value: 'ca_bn', label: 'Canada BN', abbr: 'CA' },
  { value: 'ca_gst_hst', label: 'Canada GST/HST', abbr: 'CA' },
  { value: 'ca_pst_bc', label: 'Canada PST BC', abbr: 'CA' },
  { value: 'ca_pst_mb', label: 'Canada PST MB', abbr: 'CA' },
  { value: 'ca_pst_sk', label: 'Canada PST SK', abbr: 'CA' },
  { value: 'ca_qst', label: 'Canada QST', abbr: 'CA' },
  { value: 'cd_nif', label: 'Congo DRC NIF', abbr: 'CD' },
  { value: 'ch_uid', label: 'Switzerland UID', abbr: 'CH' },
  { value: 'ch_vat', label: 'Switzerland VAT', abbr: 'CH' },
  { value: 'cl_tin', label: 'Chile TIN', abbr: 'CL' },
  { value: 'cm_niu', label: 'Cameroon NIU', abbr: 'CM' },
  { value: 'cn_tin', label: 'China TIN', abbr: 'CN' },
  { value: 'co_nit', label: 'Colombia NIT', abbr: 'CO' },
  { value: 'cr_tin', label: 'Costa Rica TIN', abbr: 'CR' },
  { value: 'cv_nif', label: 'Cape Verde NIF', abbr: 'CV' },

  // D
  { value: 'de_stn', label: 'Germany STN', abbr: 'DE' },
  { value: 'do_rcn', label: 'Dominican Republic RCN', abbr: 'DO' },

  // E
  { value: 'ec_ruc', label: 'Ecuador RUC', abbr: 'EC' },
  { value: 'eg_tin', label: 'Egypt TIN', abbr: 'EG' },
  { value: 'es_cif', label: 'Spain CIF', abbr: 'ES' },
  { value: 'et_tin', label: 'Ethiopia TIN', abbr: 'ET' },
  { value: 'eu_oss_vat', label: 'EU OSS VAT', abbr: 'EU' },
  { value: 'eu_vat', label: 'European Union VAT', abbr: 'EU' },

  // G
  { value: 'gb_vat', label: 'United Kingdom VAT', abbr: 'GB' },
  { value: 'ge_vat', label: 'Georgia VAT', abbr: 'GE' },
  { value: 'gn_nif', label: 'Guinea NIF', abbr: 'GN' },

  // H
  { value: 'hk_br', label: 'Hong Kong BR', abbr: 'HK' },
  { value: 'hr_oib', label: 'Croatia OIB', abbr: 'HR' },
  { value: 'hu_tin', label: 'Hungary TIN', abbr: 'HU' },

  // I
  { value: 'id_npwp', label: 'Indonesia NPWP', abbr: 'ID' },
  { value: 'il_vat', label: 'Israel VAT', abbr: 'IL' },
  { value: 'in_gst', label: 'India GST', abbr: 'IN' },
  { value: 'is_vat', label: 'Iceland VAT', abbr: 'IS' },

  // J
  { value: 'jp_cn', label: 'Japan CN', abbr: 'JP' },
  { value: 'jp_rn', label: 'Japan RN', abbr: 'JP' },
  { value: 'jp_trn', label: 'Japan TRN', abbr: 'JP' },

  // K
  { value: 'ke_pin', label: 'Kenya PIN', abbr: 'KE' },
  { value: 'kg_tin', label: 'Kyrgyzstan TIN', abbr: 'KG' },
  { value: 'kh_tin', label: 'Cambodia TIN', abbr: 'KH' },
  { value: 'kr_brn', label: 'South Korea BRN', abbr: 'KR' },
  { value: 'kz_bin', label: 'Kazakhstan BIN', abbr: 'KZ' },

  // L
  { value: 'la_tin', label: 'Laos TIN', abbr: 'LA' },
  { value: 'li_uid', label: 'Liechtenstein UID', abbr: 'LI' },
  { value: 'li_vat', label: 'Liechtenstein VAT', abbr: 'LI' },

  // M
  { value: 'ma_vat', label: 'Morocco VAT', abbr: 'MA' },
  { value: 'md_vat', label: 'Moldova VAT', abbr: 'MD' },
  { value: 'me_pib', label: 'Montenegro PIB', abbr: 'ME' },
  { value: 'mk_vat', label: 'North Macedonia VAT', abbr: 'MK' },
  { value: 'mr_nif', label: 'Mauritania NIF', abbr: 'MR' },
  { value: 'mx_rfc', label: 'Mexico RFC', abbr: 'MX' },
  { value: 'my_frp', label: 'Malaysia FRP', abbr: 'MY' },
  { value: 'my_itn', label: 'Malaysia ITN', abbr: 'MY' },
  { value: 'my_sst', label: 'Malaysia SST', abbr: 'MY' },

  // N
  { value: 'ng_tin', label: 'Nigeria TIN', abbr: 'NG' },
  { value: 'no_vat', label: 'Norway VAT', abbr: 'NO' },
  { value: 'no_voec', label: 'Norway VOEC', abbr: 'NO' },
  { value: 'np_pan', label: 'Nepal PAN', abbr: 'NP' },
  { value: 'nz_gst', label: 'New Zealand GST', abbr: 'NZ' },

  // O
  { value: 'om_vat', label: 'Oman VAT', abbr: 'OM' },

  // P
  { value: 'pe_ruc', label: 'Peru RUC', abbr: 'PE' },
  { value: 'ph_tin', label: 'Philippines TIN', abbr: 'PH' },

  // R
  { value: 'ro_tin', label: 'Romania TIN', abbr: 'RO' },
  { value: 'rs_pib', label: 'Serbia PIB', abbr: 'RS' },
  { value: 'ru_inn', label: 'Russia INN', abbr: 'RU' },
  { value: 'ru_kpp', label: 'Russia KPP', abbr: 'RU' },

  // S
  { value: 'sa_vat', label: 'Saudi Arabia VAT', abbr: 'SA' },
  { value: 'sg_gst', label: 'Singapore GST', abbr: 'SG' },
  { value: 'sg_uen', label: 'Singapore UEN', abbr: 'SG' },
  { value: 'si_tin', label: 'Slovenia TIN', abbr: 'SI' },
  { value: 'sn_ninea', label: 'Senegal NINEA', abbr: 'SN' },
  { value: 'sr_fin', label: 'Suriname FIN', abbr: 'SR' },
  { value: 'sv_nit', label: 'El Salvador NIT', abbr: 'SV' },

  // T
  { value: 'th_vat', label: 'Thailand VAT', abbr: 'TH' },
  { value: 'tj_tin', label: 'Tajikistan TIN', abbr: 'TJ' },
  { value: 'tr_tin', label: 'Turkey TIN', abbr: 'TR' },
  { value: 'tw_vat', label: 'Taiwan VAT', abbr: 'TW' },
  { value: 'tz_vat', label: 'Tanzania VAT', abbr: 'TZ' },

  // U
  { value: 'ua_vat', label: 'Ukraine VAT', abbr: 'UA' },
  { value: 'ug_tin', label: 'Uganda TIN', abbr: 'UG' },
  { value: 'us_ein', label: 'United States EIN', abbr: 'US' },
  { value: 'uy_ruc', label: 'Uruguay RUC', abbr: 'UY' },
  { value: 'uz_tin', label: 'Uzbekistan TIN', abbr: 'UZ' },
  { value: 'uz_vat', label: 'Uzbekistan VAT', abbr: 'UZ' },

  // V
  { value: 've_rif', label: 'Venezuela RIF', abbr: 'VE' },
  { value: 'vn_tin', label: 'Vietnam TIN', abbr: 'VN' },

  // Z
  { value: 'za_vat', label: 'South Africa VAT', abbr: 'ZA' },
  { value: 'zm_tin', label: 'Zambia TIN', abbr: 'ZM' },
  { value: 'zw_tin', label: 'Zimbabwe TIN', abbr: 'ZW' },
] 

export const BILLINGADDRESS_INITIAL_DATA = {
    'billing_details': {
      'address': {
        'city': null,
        'country': null,
        'line1': null,
        'line2': null,
        'postal_code': null,
        'state': null
      },
      'email': null,
      'name': null,
    },
    'metadata': {
      'business_name': null,
      'tax_id_type': null,
      'tax_id_value': null
    },
  }
